import React from "react";
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WarningIcon from '@mui/icons-material/Warning';
import { usePhoneMode } from "../../hooks";

export default function EngineInfoHistoryTab({ rows }) {
    const { isMobile, isLandscape, phoneMode } = usePhoneMode();
    const landscapeMode = isMobile && isLandscape;
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height;

    let heightOffset = '9.0em';
    if (phoneMode || landscapeMode) {
        heightOffset = '7.0em';
    }

    return (
        <div>
            <TableContainer style={{ maxHeight: `calc(100vh - ${scrollViewerTop}px - ${heightOffset})` }}>
                <Table stickyHeader size={isMobile ? "small" : "medium"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date{phoneMode ? '/Type' : null}</TableCell>
                            {!phoneMode ? <TableCell>Type</TableCell> : null}
                            <TableCell>Name{phoneMode ? '/Status' : null}</TableCell>
                            {!phoneMode ? <TableCell>Status</TableCell> : null}
                            <TableCell>Bulletin</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rows || []).map((row, index) => (
                            <StyledTableRow key={index} typeDescription={row.typeDescription} status={row.status}>
                                <StyledTableCell typeDescription={row.typeDescription} status={row.status}>
                                    {row.date}
                                    {phoneMode ? (<><br />{row.typeDescription}</>) : null}
                                </StyledTableCell>
                                {!phoneMode ? <StyledTableCell typeDescription={row.typeDescription} status={row.status}>{row.typeDescription}</StyledTableCell> : null}
                                <StyledTableCell typeDescription={row.typeDescription} status={row.status}>
                                    {row.typeDescription === 'Recall' && row.status === 'Open' ? (<WarningIcon style={{ height: '16px', marginBottom: '-0.1em' }} />) : null}
                                    {row.description}
                                    {phoneMode ? (<><br />Status: {row.status}</>) : null}
                                </StyledTableCell>
                                {!phoneMode ? <StyledTableCell typeDescription={row.typeDescription} status={row.status}>{row.status}</StyledTableCell> : null}
                                <StyledTableCell typeDescription={row.typeDescription} status={row.status}>
                                    {!!row.displayPartNumber ? (
                                        <>
                                            <a style={{ color: row.typeDescription === 'Recall' && row.status === 'Open' ? theme.palette.common.white : null }} href={`/literature/view/${row.partNumber}`}>
                                                {row.displayPartNumber}
                                            </a>
                                            <a style={{ color: row.typeDescription === 'Recall' && row.status === 'Open' ? theme.palette.common.white : null }} href={`/literature/view/${row.partNumber}`} target="_blank" rel="noopener noreferrer">
                                                <OpenInNewIcon style={{ height: '16px', marginBottom: '-0.1em' }} />
                                            </a>
                                        </>)
                                        : null}
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

const StyledTableRow = styled(TableRow)(({ theme, typeDescription, status }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: typeDescription === 'Recall' && status === 'Open' ? 'red' : theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    backgroundColor: typeDescription === 'Recall' && status === 'Open' ? 'red' : null,
}));

const StyledTableCell = styled(TableCell)(({ theme, typeDescription, status }) => ({
    color: typeDescription === 'Recall' && status === 'Open' ? theme.palette.common.white : null
}));